<template>
    <div class="alarm_container">
        <!-- tab start -->
        <div class="sub_category_cotainer" v-show="subTab?.length > 0">
            <div class="sub_category next" :class="locale">
                <div 
                v-for="tab in subTab" :key="tab"
                @click="subChange(tab.type)" 
                :class="tab.type == selectedTab ? 'active' : ''"   
                >
                    {{ tab.tab }}
                </div>
            </div>
        </div>
        <!-- tab end -->

        <!-- alarm start -->
        <div class="set_alarm_container not_sub_category" v-if="okNext">
            <SelectAlarm :alarmStatus="alarmStatus" :alarmList="alarmList" :routeName="routeName" @getChangedStatus="getAlarmStatus(routeName)"/>
        </div>
        <!-- alarm end -->

        <!-- search start -->
        <div class="alarm_history_container"  v-if="okNext">
            <div class="Tb_search_wrap alarm">
                <form>
                    <div class="search_wrp">
                        <input type="text" id="search" name="search" class="search_input" :placeholder="$t('alarm.score.searchCoin')"
                        v-model="searchQuery" />
                        <button class="search_clear" @click="clearSearch"></button>
                    </div>
                </form>
            </div>
        </div>
        <!-- search end -->

        <!-- coin list start -->
        <div 
        class="history_list_warp next"
        :class="[
        { 'no-permission-wrap': !okNext }
        ]"
        >
            <!-- 코인 리스트 api 불러오는 동안 로딩바  start-->
            <div class="subPage_container" v-if="!loadApi || !loadingStatus">
                <div class="loading_spinner">
                    <div class="loading_circle"></div>
                </div>
            </div>
            <!-- 코인 리스트 api 불러오는 동안 로딩바 end -->

            <!-- 권한 없을 경우 안내 멘트 start -->
            <div v-else-if="!okNext" class="ps_nodata next" style="text-align: center">
                <h4 v-dompurify-html="$t('alarm.guideMent.nextDiv')"></h4>
            </div>
            <!-- 권한 없을 경우 안내 멘트 end -->

            <!-- 코인 리스트 목록 없을 경우 start -->
            <!-- <div v-else-if="!permission"  class="ps_nodata next">
                {{ $t("popup['temError1']") }}<br/>{{ $t("popup['temError2']") }}
            </div> -->
            <!-- 코인 리스트 목록 없을 경우 end -->


            <!-- 코인 리스트 start -->
            <div class="Tb_data_rapid next" v-else>
                <ul>
                    <li v-for="(history, i) in formattedHistory" :key="i">
                        <div class="history_list_container" @click="toggle(i)" :ref="el => itemRefs[i] = el">
                            <div class="history_info_wrap">
                                <div class="next_coin_wrap">
                                    <!-- <div class="next-img">
                                        <img src="@/assets/images/dark/icon_radio_off.png" />
                                    </div> -->
                                    <div class="next-wrap">
                                        <div class="next-flex type">
                                            <div v-if="history.greenCount" class="next-signal green">
                                                <p><span>{{ history.greenCount }}</span>{{ $t("alarm.next.green") }}</p>
                                            </div>
                                            <div v-if="history.redCount" class="next-signal red">
                                                <p><span>{{ history.redCount }}</span>{{ $t("alarm.next.red") }}</p>
                                            </div>
                                            <div v-if="history.reverseCount" class="next-signal reserved">
                                                <p><span>{{ history.reverseCount }}</span>{{ $t("alarm.next.reversed") }}</p>
                                            </div>
                                            <div v-if="!history.reverseCount && !history.redCount && !history.greenCount" class="next-signal no-signal">
                                                <p>{{ $t("alarm.next.noSignal") }}</p>
                                            </div>
                                        </div>
                                        <div class="next-flex bottom">
                                            <div class="next-time-wrap">
                                                {{ history.formattedTime.Time }} 
                                                <div class="text-gray">
                                                    {{ history.formattedTime.utcTime }} 
                                                    {{ history.formattedTime.Date }} 
                                                </div>
                                            </div>
                                            <div  class="text-gray">
                                                {{ $t("alarm.next.binance") }} 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div 
                        v-if="
                            activeIndex === i && history.reverseCount || 
                            activeIndex === i && history.redCount || 
                            activeIndex === i && history.greenCount
                        " 
                        ref="detailContainer"
                        class="detail_container">
                            <ul>
                                <li 
                                v-for="(coin, idx) in history.coinList.filter(v => v.isReverse == false)" :key="idx" 
                                class="detail-wrap"
                                @click="navigateToChart(coin, idx, history)"
                                >
                                        <div class="next-img-wrap">
                                            <div class="coin_img">
                                                <img :src="getImagePath(coin.coin)"
                                                    @error="handleImageError(coin.coin, $event)" />
                                            </div>
                                            <div class="next-list-info-wrap">
                                                <span>{{ coin.coin }}/{{ coin.quote }}</span>
                                                <p 
                                                v-if="!coin.isProfit"
                                                :class="[
                                                    'next-signal',
                                                    'content',
                                                    coin.type === 'GREEN' ? 'green' : 'red'
                                                ]"
                                                >
                                                    {{ coin.type === 'GREEN' ? $t("alarm.next.green") : $t("alarm.next.red") }}
                                                </p>
                                                <p 
                                                v-else
                                                :class="[
                                                    'next-signal',
                                                    'content',
                                                    'blue'
                                                ]"
                                                >
                                                    {{ $t("alarm.next.profit") }}
                                                </p>
                                        </div>
                                    </div>
                                    <img src="@/assets/images/dark/icon_chart.svg" v-if="!chartLoad[idx]" />
                                    <div class="loading_spinner coin_list" v-else>
                                        <div class="loading_circle coin_list"></div>
                                    </div>
                                </li>
                                <div class="dashed-line" v-if="history.greenCount && history.reverseCount || history.redCount && history.reverseCount"></div>
                                <li 
                                v-for="(coin, idx) in history.coinList.filter(v => v.isReverse)" :key="idx" 
                                class="detail-wrap"
                                @click="navigateToChart(coin, idx, history)"
                                >
                                    <div class="next-img-wrap">
                                        <div class="coin_img">
                                            <img :src="getImagePath(coin.coin)"
                                                @error="handleImageError(coin.coin, $event)" />
                                        </div>
                                        <div class="next-list-info-wrap">
                                            <span>{{ coin.coin }}/{{ coin.quote }}</span>
                                                <p 
                                            :class="[
                                                'next-signal',
                                                'content',
                                                'reserved'
                                            ]"
                                            >
                                                {{ $t("alarm.next.reversed") }}
                                            </p>
                                        </div>
                                    </div>
                                    <img src="@/assets/images/dark/icon_chart.svg" v-if="!chartLoadRe[idx]" />
                                    <div class="loading_spinner coin_list" v-else>
                                        <div class="loading_circle coin_list"></div>
                                    </div>
                                </li>
                            </ul>
                            
                        </div>
                    </li>
                </ul>
              
            </div>
            <!-- 코인 리스트 end -->

        </div>
        <!-- coin list end -->
        <AlarmModal v-if="openModal" @close="goAlarmHome" :type="openModal"/>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { convertTimestamp } from "@/utils/localeTime";
import { ref, onMounted, computed, watch, nextTick } from "vue";
import { chkPermission } from '@/utils/permission.js'

import apiAlarm from "@/api/apiAlarm.js"
// import CoinList from "@/components/alarm/common/CoinList"
import SelectAlarm from "@/components/alarm/common/SelectAlarm.vue";
import AlarmModal from '@/components/alarm/common/AlarmModal.vue'

const store = useStore();
const route = useRoute();
const router = useRouter();
const type = ref(route.query?.type)
const loadApi = ref(false);
const userPackage = ref(0);
// const openModal = ref('');
const loadingStatus = ref(false);
const chartLoad = ref({});
const chartLoadRe = ref({});
const userId = ref();
const openModal = ref('');

const { t, locale } = useI18n();

// 탭별 서브 카테고리 매치
const subTab = ref([
    { tab: t('alarm.next.firstTab'), type: 'imme' }, 
    { tab: t('alarm.next.seconTab'), type: 'goya' }
]);

// 선택된 서브 카테고리
const selectedTab = ref(type.value == 'goya' ? 'goya' : 'imme')

// 서브 카테고리 변경 함수
async function subChange(query) {
    loadApi.value = false;
    
    selectedTab.value = query;
    type.value = query;
    await chgRoute();
    router.push({
        query: {
        ...route.query, 
        type: query,  
        },
    });

    loadApi.value = true;
}

// api 호출 주소 설정
const routeName = ref('');

async function chgRoute() {
    type.value == 'goya' ? routeName.value = 'next-goya-alarm' : routeName.value = 'next-direct-alarm';

    await getAlarmStatus(routeName.value);
    await setHistoryList(routeName.value);
}

// 유저 설정 알람 상태 가져오기
const alarmStatus = ref();

async function getAlarmStatus(routeName) {
    let status = await apiAlarm.getAlarms(routeName);
    alarmStatus.value = status.data
}


// 알람 리스트
const alarmList = ref([]);

async function setAlarmList() {
    let alarms = await apiAlarm.getAlarmSound();
    // // console.log('alarmList', alarms.data.length)
    for (let i = 0; i < alarms.data.length; i++) {
        let alarm = alarms.data[i]
        if (alarm.filename == 'default') {
            alarmList.value.push(t('alarm.price.default'))
        }
        else (
            alarmList.value.push(t('alarm.price.soundFormat', {number: i}))
        )
    }
}

// search 함수 / 검색어 지우기 
const searchQuery = ref("");

function clearSearch(event) {
    event.preventDefault();
    searchQuery.value = "";
}

// history
const rawHistory = ref([]); 

async function setHistoryList(routeName) {
    let historyData = await apiAlarm.getHistory(routeName + '-histories');

    rawHistory.value = historyData.data;
    // rawHistory.value[0].coinList.push(
    //     {
    //         coin: "DUSK",
    //         exchange: "Binance",
    //         isProfit: false,
    //         isReverse: true,
    //         quote: "USDT",
    //         type: "GREEN"
    //     }
    // )

    // push 알람 누르고 페이지 진입시 해당 알람 시간 드롭박스 펼쳐진 상태로 유지하는 기능
    if (route.query?.time) {
        activeIndex.value = rawHistory.value.findIndex(
            v => v.time == route.query?.time
        )
    }

    loadApi.value = true;
    // // console.log('loadApi.value', loadApi.value)
}

const formattedHistory = computed(() => {
  const keyword = searchQuery.value.trim().toLowerCase()

  return rawHistory.value
    .filter(history => {
      if (!keyword) return true

      return history.coinList?.some(coin =>
        coin.coin.toLowerCase().includes(keyword)
      )
    })
    .map(v => ({
      ...v,
      formattedTime: convertTimestamp(v.time)
    }))
})

// 이미지 호출 함수 
function getImagePath(coin) {
    const symbol = coin + "USDT";
    const baseSymbol = symbol.replace("USDT", "").toLowerCase();
    try {
      return require("@/assets/images/coin_logos/" + baseSymbol + ".svg");
    } catch {
      return require("@/assets/images/coin_logos/default.svg");
    }
}

function handleImageError(symbol, event) {
    const baseSymbol = symbol.replace('USDT', '').toLowerCase();
    event.target.src = require('@/assets/images/coin_logos/' + baseSymbol + '.png') ? require('@/assets/images/coin_logos/' + baseSymbol + '.png') : require("@/assets/images/coin_logos/default.svg");
}

const excList = {
    binance: 1,
    bybit: 2,
    okx: 3
}

// 히스토리내 몇번째인지 확인 함수 
function getOccurrenceOrder(history, clickedCoin) {
  let n = 0;

  for (const item of history.coinList) {
    if (item.coin === clickedCoin.coin) {
      n += 1;
    }

    if (item === clickedCoin) {
      return n; 
    }
  }

  return 0;
}


function navigateToChart(coin, idx, history) {
    chartLoad.value = {};
    chartLoadRe.value = {};
    // // console.log('time', time)
    // // console.log('idx', idx)

    let occur = getOccurrenceOrder(history, coin);
    let profit = coin.isReverse ? true : coin.isProfit

    if (coin.isReverse) {
        chartLoadRe.value[idx] = true;
    }
    else {
        chartLoad.value[idx] = true;
    }

    let excId = excList[coin.exchange.toLowerCase()]
    let tabType = routeName.value.includes('goya') ? 'goya' : 'imme';
    let url = `${process.env.VUE_APP_CHART_URL}/chart/next-chart.php?symbol=${coin.coin}&exchange_id=${excId}&type=${tabType}&user_id=${userId.value}&lang=${locale.value}&profit=${profit}&time=${history.time}&reverse=${coin.isReverse}&count=${occur}`;
    
    // // console.log('coin', coin)
    // console.log('url', url)
    window.location.href = url;
}

const result = ref(null);
const checkingPermission = ref(true); // 체크 완료인지 확인
const permission = ref(false); // 권한 확인
const okNext = ref(false); // next 차트 권한
const isPayment = ref(0); // 결제여부

// 스마트 플랜 권한 체크
async function chkSmartPlan() {
  try {
    result.value = await chkPermission();
    permission.value = result.value.permission;
    okNext.value = result.value.okNext;
    isPayment.value = result.value.isPayment;
    userPackage.value = result.value.userPackage;

    if (Number(userPackage.value) < 1000) {
      openModal.value = 'permission';
    }

    if (!okNext.value) {
      openModal.value = 'next';
    }
  } finally {
    checkingPermission.value = false;
  }
}

// 모달 닫기
function goAlarmHome() {
    openModal.value = '';
    router.push('/alarm/dashboard');
}

// 드롭다운
const activeIndex = ref(null)
const itemRefs = ref([])

const toggle = async(index) => {
    activeIndex.value = activeIndex.value === index ? null : index;
    await nextTick();

    const el = itemRefs.value[index]

    if (el) {
        el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
        })
    }
}


// 로그인 처리 
const loginSuccessful = computed(() => {
    return store.state.loginStatus.loginSuccessful;
}) 
// // console.log('loginSuccessful', loginSuccessful.value)

const loadSuccess = async() => {
    userId.value = localStorage.getItem("userNum");
    // // console.log('userId.value', userId.value)

    if (route.query?.symbol && route.query?.exc) {
        let url = `${process.env.VUE_APP_CHART_URL}/chart/next-chart.php?symbol=${route.query?.symbol}&exchange_id=${route.query?.exc}&type=${route.query?.type}&user_id=${userId.value}&lang=${locale.value}&profit=true&time=${route.query?.time}&reverse=false&count=1`;
        // console.log(url)
        window.location.href = url;
    }

    if (window.webkit?.messageHandlers?.loadHandler) {
        window.webkit.messageHandlers.loadHandler.postMessage('Load state changed.');
    }
    if (window.Android?.loadTriggered) {
        window.Android.loadTriggered();
    }

    await setAlarmList();
    await chkSmartPlan();
};

// Watchers
watch(loginSuccessful, async (newVal) => {
    // // console.log('loginSuccessful watcher', newVal)

    if (newVal === true) {
        await loadSuccess();
        await chgRoute();

        setTimeout(() => {
            loadingStatus.value = true;
        }, 1000);
    }
});

watch(() => route.query.type, (newV) => {
    selectedTab.value = newV;
    chgRoute();
});

// watch(() => loadingStatus.value, (newV) => {
//     // console.log('loadingStatus.value', newV)
// });

onMounted(async () => {
    await loadSuccess();
    await chgRoute();
    
    setTimeout(() => {
      loadingStatus.value = true;
    }, 1000);
})
</script>

<style scoped>
.arrow {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.rotate-down {
  transform: rotate(-180deg);
}

.Tb_data_rapid ul li:active {
    background: transparent !important;
}

.loading_spinner {
    margin: 0;
}

.ps_nodata.next {
    padding-top: 40px;
}

.next-list-info-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
</style>
